module.exports = __webpack_public_path__ + "static/media/EnvPromo-RedTree_01.b377ba6f.jpg";